import { withRouter } from 'react-router-dom'
import React from 'react'

class ScrollTop extends React.Component {
    componentDidUpdate (prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    render () {
        return (
            <div>
                {this.props.children}
            </div>)
    }
}

export default withRouter(ScrollTop)



// WEBPACK FOOTER //
// ./src/modules/layout/component/ScrollTop.js